import * as React from 'react';
import classnames from 'classnames';
import style from './TypeLabel.scss';
import { Caption } from '../../../../PageElements/Caption';
import { LABEL_TYPES } from './consts';

interface TypeLabelProps {
  type: string;
  withBorder?: boolean;
  dataHook?: string;
  className?: string;
}

export const TypeLabel = ({
  type,
  withBorder = true,
  dataHook,
}: TypeLabelProps) => {
  return (
    <Caption
      className={classnames({
        [style.label]: true,
        [style[type.toLowerCase()]]: true,
        [style.noBorder]: !withBorder,
      })}
      dataHook={`type-label${dataHook ? `-${dataHook}` : ''}`}
    >
      {LABEL_TYPES[type]}
    </Caption>
  );
};

TypeLabel.displayName = 'TypeLabel';
